// @ts-nocheck
const windowExist = typeof window !== "undefined";
const productIndex = 3;

export const push = (data: object) => {
    if (windowExist && Object.prototype.hasOwnProperty.call(window, "dataLayer")) {
        window.dataLayer?.push(data);
    }
};

export const resolveCategory = () => {
    if (windowExist) {
        const resolvedCategory = window.location.pathname
            .slice(1)
            .replace(/-/gu, " ")
            .split("/")
            .filter((category, i) => i !== 0);
        if (resolvedCategory.length === productIndex) {
            resolvedCategory.pop();
        }
        return resolvedCategory.join("/");
    }
};

export const dispatchLocationFilterEvent = (filterLabel: string) => {
    push({
        event: "whereToBuyFilter",
        eventData: {
            clickText: filterLabel,
        },
    });
};

export const dispatchLocationSearchEvent = () => {
    push({
        event: "whereToBuySearch",
    });
};

export const dispatchContactFormEvent = (topic: string | undefined) => {
    if (topic) {
        push({
            event: "contactFormTopic",
            eventData: {
                clickText: topic,
            },
        });
    }
};

export const dispatchProductListEvent = (prodTitle: string, prodURL: string) => {
    push({
        event: "productClick",
        eventData: {
            clickText: prodTitle,
            clickURL: prodURL,
        },
    });
};

export const dispatchProductCatalogEvent = (prodTitle: string, prodURL: string | undefined) => {
    push({
        event: "productCatalogClick",
        eventData: {
            clickText: prodTitle,
            clickURL: prodURL,
        },
    });
};

export const dispatchMainNavigationLocationFinderEvent = (title?: string, url?: string) => {
    push({
        event: "whereToBuyClick",
    });
};

export const dispatchMainNavigationCategoryEvent = (title?: string, url?: string) => {
    push({
        event: "productCategoryClick",
        eventData: {
            clickText: title,
            clickURL: url,
        },
    });
};

export const dispatchMainNavigationSubCategoryEvent = (title?: string, url?: string) => {
    push({
        event: "productSubcategoryClick",
        eventData: {
            clickText: title,
            clickURL: url,
        },
    });
};

export const dispatchFeaturedProductHomePageEvent = (title?: string, url?: string) => {
    push({
        event: "featuredProductClick",
        eventData: {
            clickText: title,
            clickURL: url,
        },
    });
};

export const dispatchProductCategoryHomePageEvent = (title?: string, url?: string) => {
    push({
        event: "productCategoryClick",
        eventData: {
            clickText: title,
            clickURL: url,
        },
    });
};

export const dispatchLinkListHomePageEvent = (title?: string, url?: string) => {
    push({
        event: "ressourceClick",
        eventData: {
            clickText: title,
            clickURL: url,
        },
    });
};

export const dispatchDocumentCenterClick = (title: string, url: string) => {
    push({
        event: "documentCenterClick",
        eventData: {
            documentTitle: title,
            documentUrl: url,
        },
    });
};

export const dispatchDocumentCenterUseSearch = (widgetName: string) => {
    push({
        event: "documentCenterUseSearch",
        eventData: {
            widgetName,
        },
    });
};

export const dispatchDocumentCenterSectionExpandClick = (parentName: string, sectionName: string) => {
    push({
        event: "documentCenterSectionExpandClick",
        eventData: {
            parentName,
            sectionName,
        },
    });
};
